<i18n>
{
  "en": {
    "noUploadPages": "No upload page yet, start by creating one!"
  },
  "fr": {
    "noUploadPages": "Pas de page de téléchargement, commencez par en créer une !"
  }
}
</i18n>
<template>
  <v-container>
    <v-row
      no-gutters>
      <v-col
        md="6"
        offset-md="3">
        <create-page-dialog v-if="hasConnections"/>
        <v-alert type="warning" v-else>
          You need to create a connection first before creating an upload page
        </v-alert>
        <messages-list :messages="messages"/>
        <v-data-table
          class="elevation-1 mt-5"
          :headers="headers"
          :items="pages"
          :no-data-text="$t('noUploadPages')"
          hide-default-footer
          :loading="loading"
          >
          <template v-slot:item.slug="{ item }">
            <v-btn icon color="primary" small target="_blank" :href="'/page/' + item.slug">
              <v-icon>open_in_new</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import messagesList from '@/components/messages-list'
import createPageDialog from '@/components/create-page-dialog'

export default {
  name: 'uploadPagesPage',
  components: {
    createPageDialog,
    messagesList
  },
  data () {
    return {
      headers: [{
        align: 'left',
        value: 'folderName',
        text: 'Folder Name',
        sortable: true
      }, {
        align: 'left',
        value: 'slug',
        text: 'Link'
      }],
      loading: false,
      messages: []
    }
  },
  computed: {
    connections () {
      return this.$store.getters.getConnections
    },
    hasConnections () {
      return this.connections && this.connections.length > 0
    },
    pages () {
      return this.$store.getters.getUploadPages
    }
  },
  async created () {
    this.loading = true
    await this.$store.dispatch('getOrganizationConnections')
    await this.$store.dispatch('getOrganizationUploadPages')
    this.loading = false
  }
}
</script>

<style>

</style>
